module.exports = __webpack_public_path__ + "img/choose-account.3b16d421.jpg";